<template>
    <div class="content-wrapper">
        <accordion-item
            v-for="(item, index) in content"
            :key="index"
            :id="index"
            :item="item"
            :activeId="activeId"
            :toggleAccordion="toggleAccordion"
        />
    </div>
</template>

<script>
import AccordionItem from "./AccordionItem.vue";

export default {
    name: "accordion",

    props: ["content"],

    components: {
        AccordionItem
    },

    data() {
        return {
            activeId: null,
        };
    },

    mounted() {
        if(this.$store.state.accordion_open) {
            this.activeId = this.$store.state.open_accordion_id;
        }
    },

    methods: {
        toggleAccordion(id) {
            this.activeId = id === this.activeId ? null : id;
        },
    }
};
</script>

<style lang="scss">
.content-wrapper {
    margin: var(--padding) 0;
}

@media only screen and (max-width: 767px) {
    .content-wrapper {
        margin: var(--padding) 0;
    }
}
</style>
